module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0010#pt01"
    }
  }, [_vm._v("The Selfish Youngsters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0011#ch01"
    }
  }, [_vm._v("子—What the Son Did . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Pining Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0012#ch02"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("父")]), _vm._v("—What the Father Wanted . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Chimney")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0013#ch03"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("母")]), _vm._v("—What the Mother Did Not Know . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("The Birthday Girls")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0014#pt02"
    }
  }, [_vm._v("The Willful Teenagers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0015#ch04"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("子")]), _vm._v("—With Whom the Son Took Liberties . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("If You Were My Legend")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0016#ch05"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("妹")]), _vm._v("—What the Younger Daughter Once Aspired To . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("The Match")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0017#ch06"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("姊")]), _vm._v("—How the Older Daughter Looks . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("The Homely Girl")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0018#ch07"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("父")]), _vm._v("—What the Father Is Worried About . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("The Umbrella")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0019#pt03"
    }
  }, [_vm._v("The Women in Love")]), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pviii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0020#ch08"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("姊")]), _vm._v("—What the Older Daughter Has Got . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Dream Lover")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0021#ch09"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("妹")]), _vm._v("—What the Younger Daughter Falls For . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("The Gourmet")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0022#ch10"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("母")]), _vm._v("—What the Mother Is Afraid Of . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("My Old Faithful")]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaHUANG0023#acknow"
    }
  }, [_vm._v("Acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe815dbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma-HUANG-0008.vue
// module id = 78
// module chunks = 0